/**
 * @description 设置当前模块
 */
export const getCurrentModule = (pathname = window.location.pathname) => {
  const moduleMap: Record<string, string> = {
    '/chartlet/': 'chartlet',
    '/model/': 'model',
    '/custom/': 'custom',
  };

  const matchedModule = Object.keys(moduleMap).find(key => pathname.includes(key));
  if (matchedModule) {
    return moduleMap[matchedModule]
  }
  return ''
};
export const materialTypeMap = {
  model: 1,
  chartlet: 2,
  custom: 3
}
